<template>
  <div>
    <MenuBar />

    <div id="responsiblePage" class="mobileOnly">
      <FloatingMenu />

      <transition enter-active-class="animated fadeIn" appear>
        <div class="responsiblePageTitle">
          <span v-if="this.langChosen === 'gr'">책임감있는 도박</span>
          <span v-else>Responsible Gambling</span>
        </div>
      </transition>

      <div class="heroImage" />

      <div class="contactContainer" v-if="this.langChosen === 'gr'">
        <p>
          <b>일일 자본 및 지출 한도를 관리하십시오.</b>
        </p>

        <p>
          고객 계정은 그가 베팅하고 입금 할 수있는 금액을 설정할 수 있습니다. 그의 계정은 일일 지출 한도와 일일 재정
          한도를 설정합니다.
        </p>

        <p>
          일일 자금 한도는 고객이 입금 할 수있는 최대 금액입니다. 24 시간마다 그의 계정. 금액은 외부 출처에서 들어오는
          총 금액을 기준으로 계산됩니다. 계정 고객은 75 %를 초과하거나 한도의 100 %에 도달하면 알림을받습니다. 일일 자금
          한도 일일 자본 한도의 100 %에 도달하면 입금 할 수 없습니다.
        </p>

        <p>
          일일 지출 한도는 고객이 베팅 할 수있는 최대 금액입니다. 24 시간마다 그의 계정에서 금액은 총 제품에서
          계산됩니다. 계정 클라이언트는 75 %를 초과하거나 한도의 100 %에 도달하면 알림이 전송됩니다. 일일 비용 당신은 할
          수 없습니다 일일 지출 한도의 100 %에 도달하면 베팅하세요.
        </p>

        <p>
          <b>일일 자금 및 지출 한도를 설정합니다.</b>
        </p>

        <p>
          모든 계정 신청자는 자신의 일일 자본 및 지출 한도를 온라인 등록 절차의 일부 베팅을 게시하기 전에
          singaporepools.com
        </p>

        <p>
          <b>베팅 활동 추적</b>
        </p>

        <p>
          고객 계정은 계정 요약을 통해 자신의 활동을 모니터링하거나 거래 내역 및 주간 명세서를 봅니다.
        </p>
      </div>

      <div class="contactContainer" v-else>
        <p>
          <b>Manage your Daily Funding and Expenditure Limits</b>
        </p>
        <p>
          An Account Customer can determine how much he/she can place bets from and deposit into his/her account by
          setting his/her Daily Expenditure Limit and Daily Funding Limit.
        </p>
        <p>
          Daily Funding Limit is the maximum amount an Account Customer may deposit into his Account every 24 hours. The
          amount is calculated across all various incoming funds from external sources. The Account Customer will be
          notified if he/she exceeds 75% of or reached 100% of his/her Daily Funding Limit. He/she will be unable to
          deposit funds when 100% of his/her Daily Funding Limit has been reached.
        </p>
        <p>
          Daily Expenditure Limit is the maximum amount an Account Customer can use to bet from his/her Account every 24
          hours. The amount is calculated across all products. The Account Customer will be notified if he/she exceeds
          75% of or reached 100% of his/her Daily Expenditure Limit. He/she will be unable to place bets when 100% of
          his/her Daily Expenditure Limit has been reached.
        </p>
        <p>
          <b>Setting up of Daily Funding and Expenditure Limits</b>
        </p>
        <p>
          All Account applicants are prompted to set their own Daily Funding and Expenditure Limits as part of the
          online registration process on singaporepools.com before making bet placement.
        </p>
        <p>
          <b>Keep Track Of Your Betting Activities</b>
        </p>
        <p>
          An Account Customer can keep track of his betting activities through his Account Summary or viewing the
          Transaction History and Weekly Statement.
        </p>
      </div>
    </div>

    <div id="responsibleDesktop">
      <div class="heroHeader">
        <transition enter-active-class="animated fadeIn" appear>
          <div v-if="this.langChosen === 'gr'">책임감있는 도박</div>
          <div v-else>Responsible Gambling</div>
        </transition>
      </div>

      <div class="flex">
        <LeftBannerAds />

        <div class="aboutDesktopField">
          <div v-if="this.langChosen === 'gr'">
            <p>
              <b>일일 자본 및 지출 한도를 관리하십시오.</b>
            </p>

            <p>
              고객 계정은 그가 베팅하고 입금 할 수있는 금액을 설정할 수 있습니다. 그의 계정은 일일 지출 한도와 일일 재정
              한도를 설정합니다.
            </p>

            <p>
              일일 자금 한도는 고객이 입금 할 수있는 최대 금액입니다. 24 시간마다 그의 계정. 금액은 모든 외부 입금
              자금을 기준으로 계산되며, 75 %를 초과하거나 도달하면 계정 고객 소스에 통지됩니다. 일일 자본 한도의 100 %,
              일일 자금 한도의 100 %에 도달하면 입금 할 수 없습니다.
            </p>

            <p>
              일일 지출 한도는 고객이 사용할 수있는 최대 금액입니다. 24 시간마다 그의 계좌에서 베팅하세요. 금액은 총
              제품, 고객을 기준으로 계산되며 75 %를 초과하거나 한도의 100 %에 도달하면 계정에 알림이 전송됩니다. 일일
              지출 한도의 100 %에 도달하면 일일 지출이 베팅되지 않습니다.
            </p>

            <p>
              <b>일일 자금 및 지출 한도를 설정합니다.</b>
            </p>

            <p>
              모든 계정 신청자는 일일 자금 및 지출 한도를 설정하도록 초대됩니다. 온라인 등록 절차의 일환으로 베팅을
              게시하기 전에 singaporepools.com
            </p>

            <p>
              <b>베팅 활동 추적</b>
            </p>

            <p>
              고객 계정은 계정 요약을 통해 자신의 활동을 모니터링 할 수 있습니다. 또는 주간 거래 내역 및 명세서보기
            </p>
          </div>

          <div v-else>
            <p>
              <b>Manage your Daily Funding and Expenditure Limits</b>
            </p>
            <p>
              An Account Customer can determine how much he/she can place bets from and deposit into his/her account by
              setting his/her Daily Expenditure Limit and Daily Funding Limit.
            </p>
            <p>
              Daily Funding Limit is the maximum amount an Account Customer may deposit into his Account every 24 hours.
              The amount is calculated across all various incoming funds from external sources. The Account Customer
              will be notified if he/she exceeds 75% of or reached 100% of his/her Daily Funding Limit. He/she will be
              unable to deposit funds when 100% of his/her Daily Funding Limit has been reached.
            </p>
            <p>
              Daily Expenditure Limit is the maximum amount an Account Customer can use to bet from his/her Account
              every 24 hours. The amount is calculated across all products. The Account Customer will be notified if
              he/she exceeds 75% of or reached 100% of his/her Daily Expenditure Limit. He/she will be unable to place
              bets when 100% of his/her Daily Expenditure Limit has been reached.
            </p>
            <p>
              <b>Setting up of Daily Funding and Expenditure Limits</b>
            </p>
            <p>
              All Account applicants are prompted to set their own Daily Funding and Expenditure Limits as part of the
              online registration process on singaporepools.com before making bet placement.
            </p>
            <p>
              <b>Keep Track Of Your Betting Activities</b>
            </p>
            <p>
              An Account Customer can keep track of his betting activities through his Account Summary or viewing the
              Transaction History and Weekly Statement.
            </p>
          </div>
        </div>

        <RightBannerAds />
      </div>
    </div>

    <FifthSection />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import FifthSection from '../components/FifthSection';
import MenuBar from '../components/MenuBar';
import LeftBannerAds from '../components/LeftBannerAds';
import RightBannerAds from '../components/RightBannerAds';

export default {
  components: {
    FloatingMenu,
    FifthSection,
    MenuBar,
    LeftBannerAds,
    RightBannerAds,
  },

  mounted() {
    this.setDocTitle();
  },

  methods: {
    setDocTitle() {
      if (localStorage.getItem('langChosen') === 'gr') {
        document.title = '책임감있는 도박 - 부산 복권';
      } else {
        document.title = 'Responsible Gambling - Busan Lotteries';
      }
    },
  },
};
</script>

<style>
#responsiblePage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  padding: 5vw;
  padding-top: 3.75vh;
  box-sizing: border-box;
}

.responsiblePageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
  margin-bottom: 5.5vw;
}

#responsiblePage .heroImage {
  height: 35vh;
  background: url('../assets/balance.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 2vw 2vw 0 0;
  overflow: hidden;
}

.contactContainer {
  background-color: white;
  padding: 4vw;
  border-radius: 0 0 2vw 2vw;
  font-size: 0.98em;
  line-height: 175%;
}

.contactContainer p {
  margin: 0;
  margin-bottom: 3vw;
}

.contactContainer p:last-child {
  margin-bottom: 1vw;
}

#responsibleDesktop {
  display: none;
}

@media screen and (min-width: 768px) {
  #responsibleDesktop {
    background-color: var(--darkColor);
    min-height: 100vh;
    display: block;
  }

  #responsibleDesktop .heroHeader {
    background-image: url('../assets/balance.jpg'),
      linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.6));
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-size: 6em;
    font-weight: bold;
    color: white;
    padding: 138px 0;
    background-position: top;
    text-shadow: 1px 1px 4px black;
  }

  .aboutDesktopField {
    line-height: 150%;
    font-size: 1.2em;
    width: 60%;
    margin: auto;
    height: 600px;
    overflow: scroll;
    background: var(--bluePrim-lighter-4);
    position: relative;
    top: -50px;
    padding: 15px 40px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-bottom: -50px;
  }

  #responsibleDesktop .adsSpace1,
  #responsibleDesktop .adsSpace2 {
    width: 18%;
    position: relative;
    z-index: 3;
    text-align: center;
    border-radius: 5px;
    top: -50px;
    margin-bottom: -50px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }
}
</style>
